var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowCircleRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.71 12.7099C15.801 12.6148 15.8724 12.5027 15.92 12.3799C16.02 12.1364 16.02 11.8634 15.92 11.6199C15.8724 11.4972 15.801 11.385 15.71 11.2899L12.71 8.28991C12.3179 7.89778 11.6821 7.89778 11.29 8.28991C10.8979 8.68203 10.8979 9.31778 11.29 9.70991L12.59 10.9999H9C8.44771 10.9999 8 11.4476 8 11.9999C8 12.5522 8.44771 12.9999 9 12.9999H12.59L11.29 14.2899C11.1007 14.4777 10.9942 14.7333 10.9942 14.9999C10.9942 15.2665 11.1007 15.5221 11.29 15.7099C11.4778 15.8992 11.7334 16.0057 12 16.0057C12.2666 16.0057 12.5222 15.8992 12.71 15.7099L15.71 12.7099ZM22 12.0002C22 6.4774 17.5228 2.00024 12 2.00024C6.47715 2.00024 2 6.4774 2 12.0002C2 17.5231 6.47715 22.0002 12 22.0002C17.5228 22.0002 22 17.5231 22 12.0002ZM4.00002 12.0005C4.00002 7.58221 7.58174 4.00049 12 4.00049C16.4183 4.00049 20 7.58221 20 12.0005C20 16.4188 16.4183 20.0005 12 20.0005C9.87828 20.0005 7.84345 19.1576 6.34316 17.6573C4.84287 16.1571 4.00002 14.1222 4.00002 12.0005Z",
    fill: "#9F248F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowCircleRight);
export default __webpack_public_path__ + "static/media/arrow-circle-right.181d9139.svg";
export { ForwardRef as ReactComponent };